export default {
  pad: function(d) { // 숫자 2자리 0으로 채우기
    return d < 10 ? "0" + d.toString() : d.toString();
  },
  isNull : function(val){ // null값인지 체크
      if("undefined" == val || null == val || "" == val.trim() ){
        return true;
      }
      return false;
  },
  getByteLength(str) { // 문자열의 byte 길이. 한글은 2byte처리하고, 특수문자중에서 XssCodec.encode에서 변환시키는 것은 미리 사이즈 변경해서 체크한다. 
    var len = 0;
    var kor = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;
    var spc4 = ['<','>'];
    var spc5 = ['&','(','"','\'','/'];
    var spc6 = ['"','\'','/'];

    if(!str){
      return 0;
    }

    for (var i = 0; i < str.length; i++) {
      var char = str.charAt(i);
      if (kor.test(char)) { // 한글은 2byte
        len += 2;
      } else if (this.checkSpcChar(spc4,char)){
        len += 4;
        //console.log("getByteLength 4 len",len);
      } else if (this.checkSpcChar(spc5,char)){
        len += 5;
        //console.log("getByteLength 5 len",len);
      } else if (this.checkSpcChar(spc6,char)){
        len += 6;
        //console.log("getByteLength 6 len",len);
      } else {
        len += 1;
      }
    }
    //console.log("getByteLength len",len);
    return len;
  },
  checkSpcChar(spcArray, char){
    var val = false;
    //console.log("spcArray char",char);
    spcArray.forEach(function(element){
      //console.log("spcArray element",element);
      if(element == char){
        //console.log("spcArray element char",element + ',' +char);
        val = true;
      }
    });
    return val;
  },
  checkOverLength : function(val, len, title){ // 허용 길이 체크 후 넘으면 경고창 호출.
      if (this.getByteLength(val) > len){                    
          var msg = title + '의 최대 입력 길이는 ' + len + '입니다. 현재('+this.getByteLength(val)+')';
          alert(msg);
          return true;
      }
      return false;
  }
}
